export enum SkillEndpoints {
  FetchSkills = '/skills',
}
